import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('.site-container');

class LanguageModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: false,
        };

        this.body = document.querySelector('body');
        this.language = 'nl';
        this.copy = window.drupalSettings.languageModal[this.language];
    }

    componentWillMount() {
        const langSwitchLinks = document.querySelectorAll('[data-lang-switch-link]');

        [...langSwitchLinks].forEach((link) => {
            link.addEventListener('click', (event) => {
                if (link.getAttribute('href') === '#') {
                    event.preventDefault();

                    this.language = link.dataset.lang;
                    this.copy = window.drupalSettings.languageModal[this.language];
                    this.openModal();
                }
            });
        });
    }

    openModal = () => {
        this.setState({
            modalIsOpen: true,
        });

        this.body.classList.add('disable-scroll');
    }

    closeModal = () => {
        this.setState({
            modalIsOpen: false,
        });

        const base = window.location.toString().split('?')[0];
        history.pushState({}, '', base); // eslint-disable-line no-restricted-globals

        this.body.classList.remove('disable-scroll');
    }

    render = () => {
        const {
            title,
            close,
            button,
        } = this.copy;

        const {
            modalIsOpen,
        } = this.state;

        return (
            <Modal
                className="modal"
                overlayClassName="modal__overlay"
                isOpen={modalIsOpen}
                onRequestClose={this.closeModal}
                contentLabel={title}
            >
                <button className="modal__close" type="button" onClick={this.closeModal}>
                    <span className="visually-hidden">{close}</span>
                    <svg className="icon-small" viewBox="0 0 18 18" role="presentation" focusable="false">
                        <use xlinkHref="#icon-close" />
                    </svg>
                </button>

                <div className="text">
                    <h2 className="modal__title">{title}</h2>
                    <div className="button-group">
                        <a className="button" href={`/${this.language}`} type="button">{button}</a>
                        <button className="underline-link" type="button" onClick={this.closeModal}>{close}</button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default LanguageModal;
